import { isScriptLoaded, markScriptLoaded } from '@/scripts/core/loaded';

const SECTION_NAME = 'most-viewed';

function mostViewedVideos() {
    const videoTriggers = document.querySelectorAll('[data-most-viewed]');

    videoTriggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
            const videoID = trigger.getAttribute('data-most-viewed');

            window.initBambuserLiveShopping({
                showId: videoID,
                type: 'overlay'
            });
        });
    });
}

const run = () => {
    mostViewedVideos();
};

// Ensure section JS only runs once
if (!isScriptLoaded(SECTION_NAME)) {
    document.addEventListener('DOMContentLoaded', run);
    document.addEventListener('shopify:section:load', run);

    markScriptLoaded(SECTION_NAME);
}
